import { getRuleErrorMessage, URLRegex } from "@/utils/formHelper";
import { qrListPickerValidations, qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const qrBusinessValidation = (data, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "companyName",
      rules: {
        maxLength: {
          value: 50,
          message: getRuleErrorMessage("companyName", "maxLength", data),
        },
      },
    },
    {
      name: "title",
      rules: {
        maxLength: {
          value: 50,
          message: getRuleErrorMessage("title", "maxLength", data),
        },
      },
    },
    {
      name: "buttonText",
      rules: {
        maxLength: {
          value: 50,
          message: getRuleErrorMessage("buttonText", "maxLength", data),
        },
      },
    },
    {
      name: "buttonUrl",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("buttonUrl", "pattern", data),
        },
      },
    },
    {
      name: "address",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("address", "maxLength", data),
        },
      },
    },
    {
      name: "numeration",
      rules: {
        maxLength: {
          value: 40,
          message: getRuleErrorMessage("numeration", "maxLength", data),
        },
      },
    },
    {
      name: "zipCode",
      rules: {
        maxLength: {
          value: 40,
          message: getRuleErrorMessage("zipCode", "maxLength", data),
        },
      },
    },
    {
      name: "city",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("city", "maxLength", data),
        },
      },
    },
    {
      name: "state",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("state", "maxLength", data),
        },
      },
    },
    {
      name: "country",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("country", "maxLength", data),
        },
      },
    },
    {
      name: "contactName",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("contactName", "maxLength", data),
        },
      },
    },
    {
      name: "contactPhone",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("contactPhone", "maxLength", data),
        },
      },
    },
    {
      name: "contactEmail",
      rules: {
        pattern: {
          value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g,
          message: getRuleErrorMessage("contactEmail", "pattern", data),
        },
      },
    },
    {
      name: "contactWebsite",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("contactWebsite", "pattern", data),
        },
      },
    },
    {
      name: "aboutTheCompany",
      rules: {
        maxLength: {
          value: 200,
          message: getRuleErrorMessage("aboutTheCompany", "maxLength", data),
        },
      },
    },
    ...qrListPickerValidations("social_invalid", t),
  ];
};
